import React from "react";

const TwoPhoneSection = ({ heading, showBtn, className, btnLayout }) => {
  return (
    <section className={`section-p ${className}`}>
      <div className="page-width">
        <div className={`home__section2 ${className}`}>
          <div className="home__section2__left">
            <img
              src={
                require("../../assets/images/pages/home/section_2/home_sec_2.svg")
                  .default
              }
              alt="Section 2"
            />
          </div>
          <div className="home__section2__right">
            <h1
              className={`home__section2__right-txt1 text-jost-sb-50${
                className ? "" : "-wt"
              }`}
            >
              {heading}
            </h1>
            <div className="home__section2__right-para">
              <p className="text-ops-rg-22-wt">
                Speed up rounds and increase efficiency on the course
              </p>
              <p className="text-ops-rg-22-wt">
                Connect with other golfers in a new app-based community
              </p>
              <p className="text-ops-rg-22-wt">
                Communicate between clubs and players on the course
              </p>
            </div>
            {showBtn && btnLayout}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TwoPhoneSection;
